import { ThemeConfig } from "@presentation/theme/ThemeConfig";
import { Settings } from "@config/tenants/bootstrap";

export const useTheme = (): ThemeConfig => {
  return Settings.theme;
};
